// Короткий "пип" через Web Audio API. Не требует внешнего аудио-файла.
// Вибро — через navigator.vibrate, если поддерживается устройством.

let audioCtx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (audioCtx) return audioCtx;
  const AC = window.AudioContext || (window as any).webkitAudioContext;
  if (!AC) return null;
  audioCtx = new AC();
  return audioCtx;
}

export function playScanBeep(): void {
  const ctx = getCtx();
  if (!ctx) return;
  // Первый user-gesture уже произошёл (тап по "Сканировать"), контекст
  // должен быть разрешён. Если suspended — попробуем resume().
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = 1200;
  gain.gain.setValueAtTime(0.001, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
  osc.connect(gain).connect(ctx.destination);
  osc.start();
  osc.stop(ctx.currentTime + 0.17);
}

export function vibrateScanSuccess(): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    navigator.vibrate(80);
  }
}

export function notifyScanSuccess(): void {
  playScanBeep();
  vibrateScanSuccess();
}
